import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pt-4 tw-px-4 tw-bg-[#E6E7E8]" }, null, -1)
const _hoisted_2 = { class: "tw-px-4 tw-mt-4" }
const _hoisted_3 = { class: "tw-bg-white tw-rounded-tl-3xl tw-rounded-tr-3xl tw-text-left tw-px-7 tw-py-5 tw-shadow-lg tw-z-[0.5]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-items-center tw-flex tw-text-left"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl tw-mb-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#sendMailModal"
}, "NEW MESSAGE", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "modal fade",
  id: "sendMailModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "modal-dialog" }
const _hoisted_9 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_11 = { class: "tw-flex tw-gap-5 tw-justify-between tw-pl-[25px] tw-pr-[25px] tw-mb-4 tw-mt-4" }
const _hoisted_12 = { class: "tw-w-1/3 tw-overflow-hidden" }
const _hoisted_13 = { class: "tw-w-1/3 tw-overflow-hidden" }
const _hoisted_14 = { class: "tw-w-1/3 tw-overflow-hidden" }
const _hoisted_15 = { class: "tw-flex tw-items-center tw-mt-4 tw-justify-left tw-pl-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "checked-checkbox",
  class: "tw-ml-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300"
}, "Inspection Mail", -1)
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "TO: ", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[22px]" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "ADDRESS: ", -1)
const _hoisted_23 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[20px]" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "DATE: ", -1)
const _hoisted_25 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[27px]" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "HOUR: ", -1)
const _hoisted_27 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300" }, "Customer Information", -1)
const _hoisted_30 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "NAME: ", -1)
const _hoisted_32 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "PHONE NUMBER: ", -1)
const _hoisted_34 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "EMAIL: ", -1)
const _hoisted_36 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_37 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_38 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_39 = { class: "tw-flex tw-w-2/3 tw-mt-3 tw-justify-start tw-items-center tw-gap-5" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  selected: ""
}, "Select", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Pending", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Done", -1)
const _hoisted_43 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select user type", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "MLO", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Title Company", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Inspector", -1)
const _hoisted_48 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_50 = { class: "tw-position-relative" }
const _hoisted_51 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-text-xl" }, "MESSAGE")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = {
  key: 0,
  class: "tw-flex"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-px-1" }, "DATE: ", -1)
const _hoisted_59 = {
  key: 1,
  class: "tw-flex"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-px-1" }, "DATE: ", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = {
  key: 2,
  class: "tw-text-left"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "TO")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL: ", -1)
const _hoisted_67 = {
  key: 3,
  class: "tw-text-left"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "TO")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL: ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_71 = {
  key: 4,
  class: "tw-text-left"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "FROM REALTOR")
], -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = { class: "tw-text-left" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "CUSTOMER INFORMATION")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL: ", -1)
const _hoisted_81 = {
  key: 5,
  class: "tw-text-left"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "INSPECTION")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", null, "INSPECTION ADDRESS: ", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", null, "DATE: ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", null, "HOUR: ", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "COMENTARY")
], -1)
const _hoisted_88 = { class: "tw-text-justify" }
const _hoisted_89 = { class: "tw-break-all tw-w-full" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "accept btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)
const _hoisted_92 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_93 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_94 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_95 = { class: "tw-flex tw-items-center tw-justify-between tw-text-black tw-w-full" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-start tw-gap-5 tw-w-1/5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Message")
], -1)
const _hoisted_97 = {
  key: 0,
  class: "tw-w-1/5"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", null, "Customer Name", -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 1,
  class: "tw-w-1/5"
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", null, "Customer Phone Number", -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = {
  key: 2,
  class: "tw-w-1/5"
}
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", null, "Received", -1)
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = {
  key: 3,
  class: "tw-w-1/5"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  key: 4,
  class: "tw-w-1/5"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = {
  key: 5,
  class: "tw-w-1/5"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-1/5" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-1/5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date")
], -1)
const _hoisted_117 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4"
}
const _hoisted_118 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  key: 0,
  class: "fas fa-envelope message"
}
const _hoisted_121 = {
  key: 1,
  class: "fas fa-envelope-open message"
}
const _hoisted_122 = { class: "123 tw-text-left tw-w-full" }
const _hoisted_123 = { class: "tw-text-[#656565] tw-font-bold" }
const _hoisted_124 = { class: "tw-block w-100" }
const _hoisted_125 = {
  key: 0,
  class: "tw-w-1/5"
}
const _hoisted_126 = {
  key: 1,
  class: "tw-w-1/5"
}
const _hoisted_127 = {
  key: 2,
  class: "tw-w-1/5"
}
const _hoisted_128 = {
  key: 3,
  class: "tw-w-1/5"
}
const _hoisted_129 = { class: "tw-flex tw-justify-end tw-items-center tw-pr-10" }
const _hoisted_130 = {
  key: 0,
  class: "tw-text-center tw-py-8 tw-text-gray-500"
}
const _hoisted_131 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { class: "tw-flex tw-justify-start tw-gap-5" }
const _hoisted_134 = {
  key: 0,
  class: "fas fa-envelope-open message"
}
const _hoisted_135 = { class: "123 tw-text-left tw-w-full" }
const _hoisted_136 = { class: "tw-text-[#656565] tw-font-bold" }
const _hoisted_137 = { class: "tw-block w-100" }
const _hoisted_138 = { class: "tw-flex tw-justify-end tw-items-center tw-pr-10 m-1" }
const _hoisted_139 = {
  class: "modal fade modal-xl",
  id: "modalInspectorType",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_140 = { class: "modal-dialog" }
const _hoisted_141 = { class: "modal-content" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    onclick: "$('.modal').modal('hide');",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_143 = { class: "modal-body" }
const _hoisted_144 = { class: "tw-flex tw-justify-start" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_146 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_147 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "INSPECTOR TYPE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CHOOSE")
  ])
], -1)
const _hoisted_149 = ["onClick"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = {
  class: "modal fade modal-xl",
  id: "exampleModalMLO",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_153 = { class: "modal-dialog" }
const _hoisted_154 = { class: "modal-content" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    onclick: "$('.modal').modal('hide');",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_156 = { class: "modal-body" }
const _hoisted_157 = { class: "tw-flex tw-justify-start" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_159 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_160 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CHOOSE")
  ])
], -1)
const _hoisted_162 = { key: 0 }
const _hoisted_163 = ["onClick"]
const _hoisted_164 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_165 = [
  _hoisted_164
]
const _hoisted_166 = { key: 1 }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_168 = [
  _hoisted_167
]
const _hoisted_169 = {
  class: "modal fade modal-xl",
  id: "exampleModalINSPECTOR",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_170 = { class: "modal-dialog" }
const _hoisted_171 = { class: "modal-content" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    onclick: "$('.modal').modal('hide');",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_173 = { class: "modal-body" }
const _hoisted_174 = { class: "tw-flex tw-justify-start" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_176 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_177 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CHOOSE")
  ])
], -1)
const _hoisted_179 = { key: 0 }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_182 = [
  _hoisted_181
]
const _hoisted_183 = { key: 1 }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_185 = [
  _hoisted_184
]
const _hoisted_186 = {
  class: "modal fade modal-xl",
  id: "exampleModalTITLE",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_187 = { class: "modal-dialog" }
const _hoisted_188 = { class: "modal-content" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_190 = { class: "modal-body" }
const _hoisted_191 = { class: "tw-flex tw-justify-start" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_193 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_194 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMPANY NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CHOOSE")
  ])
], -1)
const _hoisted_196 = { key: 0 }
const _hoisted_197 = ["onClick"]
const _hoisted_198 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_199 = [
  _hoisted_198
]
const _hoisted_200 = { key: 1 }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_202 = [
  _hoisted_201
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading, {
      active: _ctx.loaderConfig.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
      "can-cancel": false,
      loader: 'dots',
      "is-full-page": !_ctx.loaderConfig.fullPage
    }, null, 8, ["active", "is-full-page"]),
    _createVNode(_component_TopBar),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userRole == 'Realtor')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalListUsers(2))),
                    role: "button",
                    class: "tw-bg-[#00a0da] tw-text-white tw-w-full tw-truncate tw-whitespace-nowrap tw-font-bold tw-rounded-full tw-text-[12px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                    href: ""
                  }, "Users-Mlo")
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeInspectors())),
                    role: "button",
                    class: "tw-bg-[#00a0da] tw-text-white tw-w-full tw-truncate tw-whitespace-nowrap tw-font-bold tw-rounded-full tw-text-[12px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                    href: ""
                  }, "Users-Inspector")
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalListUsers(3))),
                    role: "button",
                    class: "tw-bg-[#00a0da] tw-text-white tw-w-full tw-truncate tw-whitespace-nowrap tw-font-bold tw-rounded-full tw-text-[12px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                    href: ""
                  }, "Users-Title Company")
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  checked: "",
                  id: "checked-checkbox",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isinspection) = $event)),
                  value: "",
                  class: "tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500 tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 tw-focus:ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isinspection]
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-h-[32px]",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mail.mailto) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.mailto]
                  ])
                ]),
                (_ctx.isinspection)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "tw-w-full tw-h-[32px]",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mail.inspection_address) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.mail.inspection_address]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "tw-w-full date-input-inspectio tw-h-[32px]",
                          modelValue: _ctx.mail.inspection_date,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mail.inspection_date) = $event)),
                          format: _ctx.formatInspectionDate,
                          placeholder: "00/00/0000"
                        }, null, 8, ["modelValue", "format"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "tw-w-full date-input-inspectio tw-h-[32px]",
                          modelValue: _ctx.mail.inspection_hour,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mail.inspection_hour) = $event)),
                          "time-picker": "",
                          placeholder: "00:00"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-h-[32px]",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mail.subject) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.subject]
                  ])
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-h-[32px]",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mail.cus_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.cus_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-h-[32px]",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mail.cus_phone) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.cus_phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-h-[32px]",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.mail.cus_email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.cus_email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "",
                    id: "",
                    rows: "6",
                    maxlength: "105",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mail.message) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mail.message]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sendMail($event)))
                  }, "SEND MESSAGE")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          (_ctx.usersession.role != 'Realtor')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": [
                  _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.read) = $event)),
                  _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.changeRead && _ctx.changeRead(...args)))
                ],
                class: "btn-select tw-bg-[#00a0da] tw-text-white tw-pl-3 tw-pr-5 tw-pt-2 tw-pb-2 tw-rounded-full tw-cursor-pointer"
              }, _hoisted_43, 512)), [
                [_vModelSelect, _ctx.filters.read]
              ])
            : _createCommentVNode("", true),
          (_ctx.usersession.role != 'Realtor')
            ? (_openBlock(), _createBlock(_component_datepicker, {
                key: 1,
                "auto-apply": "",
                class: "",
                style: {"width":"8cm"},
                range: "",
                "text-input": _ctx.configDatePicker,
                modelValue: _ctx.configDatePicker.date,
                "onUpdate:modelValue": [
                  _cache[17] || (_cache[17] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                  _ctx.changeDate
                ],
                placeholder: "Enter date range..."
              }, null, 8, ["text-input", "modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.usersession.role == 'Realtor')
            ? (_openBlock(), _createBlock(_component_datepicker, {
                key: 2,
                "auto-apply": "",
                class: "",
                style: {"width":"8cm"},
                range: "",
                "text-input": _ctx.configDatePicker,
                modelValue: _ctx.configDatePicker.date,
                "onUpdate:modelValue": [
                  _cache[18] || (_cache[18] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                  _ctx.changeDateRealtor
                ],
                placeholder: "Enter date range..."
              }, null, 8, ["text-input", "modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.usersession.role == 'Realtor')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 3,
                class: "form-select rounded-pill bg-light text-secondary",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedRole) = $event)),
                onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.fetchEmails && _ctx.fetchEmails(...args)))
              }, _hoisted_48, 544)), [
                [_vModelSelect, _ctx.selectedRole]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              (_ctx.mailselected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    _hoisted_56,
                    (_ctx.usersession.role != 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.date1), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.usersession.role == 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.mail_date), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_61,
                    (_ctx.usersession.role != 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", null, [
                            _hoisted_64,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.fromdata[0].username + " " +
                                            _ctx.mailselected.fromdata[0].lastname), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_65,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.fromdata[0].phone_Number), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_66,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.fromdata[0].email), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.usersession.role == 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", null, [
                            _hoisted_69,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.mail_to), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_70,
                    (!_ctx.mailselected.inspection_mail && _ctx.usersession.role != 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _hoisted_72,
                          _createElementVNode("div", null, [
                            _hoisted_73,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.todata[0].username + " " + _ctx.mailselected.todata[0].lastname), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_74,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.todata[0].phone_Number), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("div", null, [
                        _hoisted_78,
                        _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.cus_name), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_79,
                        _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.cus_phone), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_80,
                        _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.cus_email), 1)
                      ])
                    ]),
                    (_ctx.mailselected.inspection_mail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _hoisted_82,
                          _createElementVNode("div", null, [
                            _hoisted_83,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.inspection_address), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_84,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.inspectiondate), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_85,
                            _createElementVNode("span", null, _toDisplayString(_ctx.mailselected.inspection_hour), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_86,
                    _hoisted_87,
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.mailselected.message), 1)
                    ]),
                    _hoisted_90
                  ]))
                : _createCommentVNode("", true),
              _hoisted_91
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                (_ctx.usersession.role != 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_99))
                  : _createCommentVNode("", true),
                (_ctx.usersession.role != 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102))
                  : _createCommentVNode("", true),
                (_ctx.usersession.role != 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, _hoisted_105))
                  : _createCommentVNode("", true),
                (_ctx.usersession.role == 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
                  : _createCommentVNode("", true),
                (_ctx.usersession.role == 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_111))
                  : _createCommentVNode("", true),
                (_ctx.usersession.role == 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
                  : _createCommentVNode("", true),
                _hoisted_115,
                _hoisted_116
              ])
            ])
          ]),
          (_ctx.usersession.role != 'Realtor')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.listMails, (mail, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (!mail.deleted_from && _ctx.usersession.role == 'Realtor' || !mail.deleted_to && _ctx.usersession.role != 'Realtor')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", {
                            type: "button",
                            class: "user-message tw-flex tw-items-center tw-justify-between tw-text-black tw-w-full",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#exampleModal",
                            onClick: ($event: any) => (_ctx.selectMail(mail))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["tw-flex tw-justify-start tw-gap-5", { 'tw-w-1/2': _ctx.usersession.role != 'Realtor', 'tw-w-1/5': _ctx.usersession.role != 'Realtor' }])
                            }, [
                              (mail.mailopen == 0 && _ctx.usersession.role != 'Realtor')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_120))
                                : _createCommentVNode("", true),
                              (mail.mailopen == 1 || _ctx.usersession.role == 'Realtor')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_121))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("p", _hoisted_123, _toDisplayString(mail.subject), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_124, _toDisplayString(mail.message), 1)
                                ])
                              ])
                            ], 2),
                            (_ctx.usersession.role != 'Realtor')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                  _createElementVNode("span", null, _toDisplayString(mail.fromdata[0].username) + " " + _toDisplayString(mail.fromdata[0].lastname), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.usersession.role != 'Realtor')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                  _createElementVNode("span", null, _toDisplayString(mail.fromdata[0].phone_Number), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.usersession.role != 'Realtor')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                  _createElementVNode("span", null, _toDisplayString(mail.date2), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.usersession.role != 'Realtor')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                  _createElementVNode("span", null, _toDisplayString(mail.mail_done === 1 ? 'Done' : 'Pending'), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'tw-w-1/5': _ctx.usersession.role != 'Realtor', 'tw-w-1/2': _ctx.usersession.role != 'Realtor' })
                            }, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("span", null, _toDisplayString(mail.date2), 1)
                              ])
                            ], 2)
                          ], 8, _hoisted_119)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.usersession.role == 'Realtor')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.selectedRole == '0')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, " Please select a user type to view messages "))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredEmails, (mail, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4"
                      }, [
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("div", {
                            type: "button",
                            class: "user-message tw-flex tw-items-center tw-justify-between tw-text-black tw-w-full",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#exampleModal",
                            onClick: ($event: any) => (_ctx.selectMail(mail))
                          }, [
                            _createElementVNode("div", _hoisted_133, [
                              (mail.mailopen == 1 || _ctx.usersession.role == 'Realtor')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_134))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("p", _hoisted_136, _toDisplayString(mail.subject), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_137, _toDisplayString(mail.message), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("span", null, _toDisplayString(mail.mail_date), 1)
                              ])
                            ])
                          ], 8, _hoisted_132)
                        ])
                      ]))
                    }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_139, [
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("div", _hoisted_141, [
              _hoisted_142,
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    "aria-label": "Close",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.backModalInspector()))
                  }, [
                    _hoisted_145,
                    _createTextVNode(" Volver")
                  ])
                ]),
                _createElementVNode("div", _hoisted_146, [
                  _createElementVNode("table", _hoisted_147, [
                    _hoisted_148,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesOptions, (service, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "service"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(service), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.selectInspectorType(service)), ["prevent"])
                            }, _hoisted_151, 8, _hoisted_149)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_152, [
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("div", _hoisted_154, [
              _hoisted_155,
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    "aria-label": "Close",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.backModal()))
                  }, [
                    _hoisted_158,
                    _createTextVNode(" Volver")
                  ])
                ]),
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("table", _hoisted_160, [
                    _hoisted_161,
                    (_ctx.listuserSectionsMLO && _ctx.listuserSectionsMLO.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_162, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listuserSectionsMLO, (user, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(user.username) + " " + _toDisplayString(user.lastname), 1),
                              _createElementVNode("td", null, _toDisplayString(user.email), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  "data-bs-target": "#exampleModalloademail",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.loadEmailTo(user)), ["prevent"])
                                }, _hoisted_165, 8, _hoisted_163)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_166, _hoisted_168))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_169, [
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("div", _hoisted_171, [
              _hoisted_172,
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("div", _hoisted_174, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    "aria-label": "Close",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.backModalTypeInspector()))
                  }, [
                    _hoisted_175,
                    _createTextVNode(" Volver ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_176, [
                  _createElementVNode("table", _hoisted_177, [
                    _hoisted_178,
                    (_ctx.listUserSectionsInspector && _ctx.listUserSectionsInspector.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_179, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSectionsInspector, (user, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(user.username) + " " + _toDisplayString(user.lastname), 1),
                              _createElementVNode("td", null, _toDisplayString(user.email), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  "data-bs-target": "#exampleModalloademail",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.loadEmailToInspector(user)), ["prevent"])
                                }, _hoisted_182, 8, _hoisted_180)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_183, _hoisted_185))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_186, [
          _createElementVNode("div", _hoisted_187, [
            _createElementVNode("div", _hoisted_188, [
              _hoisted_189,
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("div", _hoisted_191, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    "aria-label": "Close",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.backModalTitle()))
                  }, [
                    _hoisted_192,
                    _createTextVNode(" Volver ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_193, [
                  _createElementVNode("table", _hoisted_194, [
                    _hoisted_195,
                    (_ctx.listUserSectionsTC && _ctx.listUserSectionsTC.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_196, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSectionsTC, (user, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(user.company_Name), 1),
                              _createElementVNode("td", null, _toDisplayString(user.email), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  "data-bs-target": "#exampleModalloademail",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.loadEmailToCompany(user)), ["prevent"])
                                }, _hoisted_199, 8, _hoisted_197)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_200, _hoisted_202))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}